import Supporter from '../utils/supporter';
import ShareWechat from '../utils/share-wechat';
import ShareSns from '../vue_components/share-sns.vue';
import CollectionList from '../vue_components/collection-list.vue';
import EventHelper from '../utils/eventHelper';
import PlainDialog from '../vue_components/plain-dialog.vue';
import questMobile from '../utils/questMobile';

export default function(cfgs){
    new Vue ({
        el: '#columnPage',
        components: {
            CollectionList,
            ShareSns,
            PlainDialog
        },
        data() {
            return {
                isShowNav: false,
                bgImgLink: '//statics.itc.cn/mobile/bg_collection.png',
                shareData: {
                    title: cfgs && cfgs.title,
                    image: '//s8.rr.itc.cn/org/wapChange/20161_5_11/b8v0r29602064149596.jpg'
                },
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                EventHelper.addHandler(window, 'scroll', ()=>{
                    var suspendHeight = document.querySelector('.suspend-nav').getBoundingClientRect().height;
                    var columnTop = document.querySelector('#collection-sp-style').getBoundingClientRect().top
                    if(columnTop <= suspendHeight) {
                        this.isShowNav = true;
                    } else {
                        this.isShowNav = false;
                    }
                })
            },
            goBack() {
                if(document.referrer){
                    history.go(-1);
                } else {
                    window.location.href="/";
                }

            },
            //显示分享
            showShare() {
                if(Supporter.isWeixin) {
                    ShareWechat({
                        title: cfgs && cfgs.title,
                        imgUrl: cfgs && cfgs.bgImgLink || '//s8.rr.itc.cn/org/wapChange/20161_5_11/b8v0r29602064149596.jpg'
                    });
                }
                window.h5_sohu.plugin.api.call('show_share', {},function(){});
                 // 给媒体日志上报广告请求事件
                if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    window.sohuSpm.sendAction({
                        acode: '8287'
                    });
                }
            },

        }

    })
    // APP增流上报请求
    questMobile()
}



